import { render, staticRenderFns } from "./NoHistory.vue?vue&type=template&id=cc830d34"
import script from "./NoHistory.vue?vue&type=script&lang=js"
export * from "./NoHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports